import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const Text = ({ lang, tid }) => {
  const text = lang?.dictionary?.[tid] ?? tid;
  return <>{text}</>;
};

Text.propTypes = {
  lang: PropTypes.object.isRequired,
  tid: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  lang: state.lang,
});

export default connect(mapStateToProps)(Text);
